module.exports = __webpack_public_path__ + "img/upload.438ddc0d.svg";